import * as React from 'react'
import intl from 'react-intl-universal'
import { Form, FormGroup, Label } from 'reactstrap'
import { IFeaturedMediaSelectorProps } from './types'
import ValidableSelect from './validableSelect'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const FeaturedMediaSelectorSFC = (
  props: IFeaturedMediaSelectorProps
) => (
  <Form onSubmit={props.onSubmit}>
    <FormGroup>
      <Label for="featuredMedia_mediaTypes">
        {intl.get('settings.featuredMedia.mediaTypes')}
      </Label>
      {props.mediaTypesValidationError && (
        <span className="validation-message">
          {props.mediaTypesValidationError}
        </span>
      )}
      <ValidableSelect
        id="featuredMedia_mediaTypes"
        isMulti={true}
        invalid={!!props.mediaTypesValidationError}
        options={props.selectOptions}
        value={props.mediaTypes}
        onChange={props.onMediaTypesChange}
      />
    </FormGroup>
    <FormGroup>
      <Label for="featuredMedia_mediaKey">
        {intl.get('settings.featuredMedia.mediaKey')}
      </Label>
      {props.mediaKeyValidationError && (
        <span className="validation-message">
          {props.mediaKeyValidationError}
        </span>
      )}
      <div className="input-group">
        <div className="input-group-prepend">
          <span
            className="input-group-text input-primary"
            id="featuredMedia_mediaKey_prep"
          >
            promo_items.
          </span>
        </div>
        <input
          type="text"
          className={`form-control${
            props.mediaKeyValidationError ? ' is-invalid' : ''
          } input-primary`}
          id="featuredMedia_mediaKey"
          placeholder={intl.get('settings.featuredMedia.mediaKeyPlaceholder')}
          aria-describedby="featuredMedia_mediaKey_prep"
          onChange={props.onMediaKeyChange}
          value={props.mediaKey}
        />
      </div>
    </FormGroup>
    <div className="form-row">
      <div className="form-group col-md-12">
        <button
          className="btn btn-primary float-right btn-sm btn-override-secondary-outline"
          type="submit"
        >
          {intl.get('settings.featuredMedia.addOption')}
        </button>
      </div>
    </div>
  </Form>
)
